<template>
  <div class="m-login__forget-password flipInX animated">
    <div class="m-login__head">
      <h3 class="m-login__title">{{ $t('Forgot password') }}</h3>
      <div class="m-login__desc">{{ $t('Forgot password give email') }}</div>
    </div>

    <b-alert class="margin-top-20"
             dismissible
             fade
             :show="showInfoAlert"
             @dismissed="showInfoAlert=false"
             variant="info">
      {{infoMessage}}
      <template slot="dismiss" class="pull-right">
        &nbsp;
      </template>
    </b-alert>

    <b-alert class="margin-top-20"
             dismissible
             fade
             :show="showErrorAlert"
             @dismissed="showErrorAlert=false"
             variant="danger">
      {{errorMessage}}
      <template slot="dismiss" class="pull-right">
        &nbsp;
      </template>
    </b-alert>


    <div class="m-login__form m-form">
      <div class="form-group m-form__group">
        <input class="form-control m-input" type="text" placeholder="Email" name="email" id="m_email"
               v-model="email"
               autocomplete="off">
      </div>
      <div class="m-login__form-action">
        <button id="m_login_forget_password_submit"
                class="btn m-btn m-btn--pill m-btn--custom m-btn--air btn-ls" @click="resetPassword">{{ $t('Send') }}
        </button>
        <button id="m_login_forget_password_cancel"
                class="btn m-btn m-btn--pill btn-outline-ls m-btn--hover-ls mb-2" @click="setSignInForm">{{ $t('Cancel') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
  import EmailValidator from 'email-validator';

  export default {
    name: "ForgotPasswordForm",
    data() {

      return {
        entity: this.entityUuid,
        email: '',
        showInfoAlert: false,
        showErrorAlert: false,
        errorMessage: '',
        infoMessage: ''
      }
    },
    methods: {
      ...mapActions([
        'setSignInForm',
        'setLoginInfo'
      ]),
      resetPassword() {
        if (!this.email.length) {
          this.showError(this.$t('Must provide email'));
          return;
        }

        if (!EmailValidator.validate(this.email)) {
          this.showError(this.$t('Check email is correct'));
          return;
        }

        this.$http.post('/password/forgot', {
          email: this.email,
          entity: this.entityUuid
        })
          .then((r) => {
            if (r.data.success) {
              this.setLoginInfo(r.data.message);
              this.setSignInForm();
            } else {
              this.showError(r.data.message);
            }
          });
      },
      showInfo(message) {
        this.showErrorAlert = false;
        this.showInfoAlert = true;
        this.infoMessage = message;
      },
      showError(message) {
        this.showErrorAlert = true;
        this.showInfoAlert = false;
        this.errorMessage = message;
      }
    },
    computed: {
      ...mapState({
        entityUuid: state => state.auth.entity.uuid,
      }),
    }
  }
</script>

<style scoped>
  .m-login__form-action > button:first-child {
    margin-right: 5px;
  }

  .margin-top-20 {
    margin-top: 20px;
  }
</style>
